import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Globe } from 'lucide-react';
import './Footer.css';

const FOOTER_LINKS = {
  'Quick Links': [
    { label: 'Home',       path: '/'          },
    { label: 'Services',   path: '/services'  },
    { label: 'Education',  path: '/education' },
    { label: 'Jobs & Visa',path: '/jobs'      },
    { label: 'Tourism',    path: '/tourism'   },
    { label: 'About Us',   path: '/about'     },
    { label: 'Contact',    path: '/contact'   },
    { label: 'Site Overview', path: '/overview' },
    { label: 'Privacy Policy',    path: '/privacy-policy'   },
  ],
  'Our Services': [
    { label: 'Private Jet Charter',     path: '/services' },
    { label: 'Hotel Accommodation',     path: '/services' },
    { label: 'Air Hostess Course',      path: '/education'},
    { label: 'Study Abroad',            path: '/education'},
    { label: 'Work Abroad – Job Visa',  path: '/jobs'     },
    { label: 'Mumbai bombay international worldwide Tourist Guide',    path: '/tourism'  },
    { label: 'Website Development',     path: '/services' },
  ],
};

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer__top">
        <div className="container footer__grid">

          {/* Brand col */}
          <div className="footer__brand">
            <Link to="/" className="footer__logo">
              Online <span>Worldwide</span>
            </Link>
            <p className="footer__tagline">
              Mumbai bombay international worldwide's most comprehensive service hub — connecting locals, students, and international visitors to everything they need.
            </p>
            <div className="footer__contacts">
              <a href="#" className="footer__contact-item">
                <MapPin size={14} /> Mumbai bombay international worldwide
              </a>
              <a href="tel:+919967765284" className="footer__contact-item">
                <Phone size={14} /> +91 9967 765284 (WhatsApp)
              </a>
              <a href="tel:+919136663456" className="footer__contact-item">
                <Phone size={14} /> +91 9136 663456
              </a>
              <a href="mailto:onlineworldwide11@gmail.com" className="footer__contact-item">
                <Mail size={14} /> onlineworldwide11@gmail.com
              </a>
              <a href="#" className="footer__contact-item">
                <Globe size={14} /> www.onlineworldwide.com
              </a>
            </div>
          </div>

          {/* Link cols */}
          {Object.entries(FOOTER_LINKS).map(([heading, links]) => (
            <div key={heading} className="footer__col">
              <h4 className="footer__col-heading">{heading}</h4>
              <ul className="footer__col-links">
                {links.map(link => (
                  <li key={link.label}>
                    <Link to={link.path} className="footer__col-link">
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          {/* Countries col */}
          <div className="footer__col">
            <h4 className="footer__col-heading">Countries We Serve</h4>
            <div className="footer__countries">
              {['Singapore','UK','USA','UAE','Germany','Japan','France','Nigeria','Russia','Dubai','Canada','Thailand'].map(c => (
                <span key={c} className="footer__country-tag">{c}</span>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div className="footer__bottom">
        <div className="container footer__bottom-inner">
          <p>© {new Date().getFullYear()} Online Worldwide. All rights reserved.</p>
          <p>Mumbai bombay international worldwide · Serving 100+ Countries Worldwide</p>
        </div>
      </div>
    </footer>
  );
}
